const comments = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20portrait%20avatar%2C%20minimalist%20geometric%20style%2C%20soft%20golden%20accents%2C%20clean%20background%2C%20artistic%20composition&width=120&height=120&seq=avatar-01&orientation=squarish',
    name: '探花迷小明',
    time: '2小时前',
    content: '探花系列平台的合集整理太用心了！探花大神的作品在这里全都能找到，而且分类特别清晰，探花一区和探花91的内容每天都有更新，已经成了我的每日必逛。',
    likes: 128,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20warm%20coral%20toned%20abstract%20portrait%20avatar%2C%20geometric%20style%2C%20soft%20lighting%2C%20clean%20background%2C%20artistic%20aesthetic&width=120&height=120&seq=avatar-02&orientation=squarish',
    name: '资源收藏家',
    time: '5小时前',
    content: '算是目前见过的探花精选内容最全的平台了，探花大神合集更新速度很快，极品探花板块的高分推荐也很有参考价值，九一探花的老资源也整理得不错。',
    likes: 96,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20amber%20toned%20abstract%20avatar%20portrait%2C%20minimalist%20geometric%20design%2C%20soft%20gradient%2C%20clean%20background%2C%20artistic%20style&width=120&height=120&seq=avatar-03&orientation=squarish',
    name: '深夜探花人',
    time: '1天前',
    content: '探花探花的推荐算法越来越精准了，每次推送的探花精品资源都正好是我喜欢的类型，探花一区的夏日专题尤其精彩，推荐给所有探花迷。',
    likes: 203,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Elegant%20warm%20toned%20abstract%20portrait%2C%20minimalist%20geometric%20avatar%20style%2C%20soft%20golden%20lighting%2C%20clean%20background%2C%20artistic%20composition&width=120&height=120&seq=avatar-04&orientation=squarish',
    name: '品质控',
    time: '2天前',
    content: '自从有了探花系列，找探花大神作品再也不用到处翻了。编辑精选的质量确实高，探花91社区的热门榜单也很实用，希望能一直保持这个更新频率。',
    likes: 157,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-18 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-4">
            <i className="ri-chat-quote-line"></i>
            用户评价
          </div>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
            探花迷怎么说
          </h2>
          <p className="mt-2 text-sm text-foreground-500 max-w-lg mx-auto">
            来自探花系列平台用户的真实声音
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 max-w-4xl mx-auto">
          {comments.map((c, i) => (
            <div
              key={i}
              className="p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70"
            >
              <div className="flex items-start gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden shrink-0 bg-background-200">
                  <img
                    src={c.avatar}
                    alt={c.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-semibold text-foreground-800">{c.name}</span>
                    <span className="text-xs text-foreground-400">{c.time}</span>
                  </div>
                  <div className="flex items-center gap-0.5 mt-0.5">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <i key={star} className="ri-star-fill text-xs text-primary-400"></i>
                    ))}
                  </div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{c.content}</p>
              <div className="mt-3 flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{c.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}